/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {CalendarEl} from 'common/components/calendar';
import {DateRangePickerEl} from 'common/widgets/date-range-picker';

import {CodeTipEl} from '../components/code-tip';
import type {DesignSystem} from '../index';
import {Section, SubSection} from './utils';

export function CalendarSection({designSystem}: {designSystem: DesignSystem}) {
  return (
    <Section title='Calendar & Date Picker'>
      <SubSection title='mp-calendar' autoDoc={true}>
        <p sel='.desc'>
          For choosing dates and date ranges. Usually embedded in drop menus, card elements, and modals.
        </p>

        <CodeTipEl sel='.example'>
          <CalendarEl
            attrs={{
              'min-date': `2015-06-10`,
              'max-date': `2016-01-20`,
              'selected-date': `2016-01-15`,
            }}
          />
        </CodeTipEl>

        <CodeTipEl sel='.example'>
          <CalendarEl
            attrs={{
              'is-double-calendar': true,
              'is-range': true,
              'min-date': `2015-12-10`,
              'max-date': `2016-01-20`,
              'is-from-date-focused': true,
              'selected-from-date': `2015-12-25`,
              'selected-to-date': `2016-01-16`,
            }}
          />
        </CodeTipEl>
      </SubSection>

      <SubSection title='mp-date-range-picker' autoDoc={true}>
        <div sel='.calendar-group'>
          <CodeTipEl sel='.example'>
            <DateRangePickerEl
              attrs={{
                'display-context': `default`,
                'date-range': designSystem.helpers.getDateRangeAttributes(),
              }}
              on={{
                changeDateRange: designSystem.helpers.updateDateRange,
              }}
            />
          </CodeTipEl>
        </div>
      </SubSection>
    </Section>
  );
}
